import React,{useState,useEffect} from 'react'
import Logo from '../Assets/Images/logo.png';
import styled from 'styled-components';
import {Drawer,Menu} from 'antd';
import { Link } from 'react-router-dom';
import MenuImage from '../Assets/Images/menu-icon.png';
import { WEB_URL } from '../config';
import API from '../ApiService/ApiService';
import { useDispatch } from 'react-redux';
const Header = () => {
  const web_url = WEB_URL;
  const api = new API();
  const [open, setOpen] = useState(false);
  const [categoryMenu, setCategoryMenu] = useState(false);
  const [categorySubMenu, setCategorySubMenu] = useState([]);
  const dispatch = useDispatch();
  const showDrawer = () => {
    setOpen(true);
  };
  const getAllCategory  = async () => {
    await api.getAll(dispatch, ["", "", "", ""], 'category/filter', {status:true}, (err, res) => {
      if(err) {
        console.log(err);
      } else {
        const menu = menuThree(res?.data?.data);
        setCategoryMenu(res?.data?.data);
        setCategorySubMenu(menu);
      }
    });
  };
  const menuThree = (menu, url = '') => {
    const list = menu?.map((e) => {
      const cat_url = `${url === '' ? `${WEB_URL}our-product/category` : url}/${e?.slug}`;
      return {
        label: <Link to={cat_url}>{e?.name}</Link>,
        key: e?._id,
        url: cat_url,
        children: e?.children?.length > 0 ? menuThree(e?.children, cat_url) : null,
      }
    }); 
    return list;
  };
  useEffect(() => {
    getAllCategory();
  }, []);
  
  const onClose = () => {
    setOpen(false);
  };
  const menu = [
    {
      label: <Link to={web_url}>Home</Link>,
    },
    {
      label: <Link to={`${web_url}about-us.php`}>About Us</Link>,
    },
    {
      label: <Link to={`${web_url}our-product/`}>Products</Link>,
      children: categorySubMenu
    },
    {
      label: <Link to={`${web_url}our-service.php`}>Services</Link>,
    },
    {
      label: <Link to={`${web_url}infrastructure.php`}>Infrastructure</Link>,
    },
    {
      label: <Link to={`${web_url}quality-control.php`}>Quality Control</Link>,
    },
    {
      label: <Link to={`${web_url}blog/`}>Blog</Link>,
    },
    {
      label: <Link to={`${web_url}contact-us.php`}>Contact Us</Link>,
    },
  ];
  // const menu = [
  //   {
  //     name: 'Home',
  //     link: web_url,
  //   },
  //   {
  //     name: 'About Us',
  //     link: `${web_url}about-us.php`,
  //   },
  //   {
  //     name: 'Products',
  //     link: `/our-product/`,
  //   },
  //   {
  //     name: 'Services',
  //     link: `${web_url}our-service.php`,
  //   },
  //   {
  //     name: 'Infrastructure',
  //     link: `${web_url}infrastructure.php`,
  //   },
  //   {
  //     name: 'Quality Control',
  //     link: `${web_url}quality-control.php`,
  //   },
  //   {
  //     name: 'Blog',
  //     link: `${web_url}blog/`,
  //   },
  //   {
  //     name: 'Contact Us',
  //     link: `${web_url}contact-us.php`,
  //   },
  // ];
  return (
    <HeaderNewSection>
      <div className='header_section'>
      <div className='wrapper'>
        <div className='header_align'>
        <div className='web_menu'>
          <Menu mode="horizontal" items={menu} />
          {/* <ul>
            {menu.map((e, i) => {
              return (
                <li key={i}>
                  <a href={e.link}>{e.name}</a>
                </li>
              )
            })}
          </ul> */}
        </div>
        <div className='logo'>
          <img src={Logo} title='Reachem Chemicals' />
        </div>
        <div className='mobile_menu'>
          <img src={MenuImage}  onClick={showDrawer}/>
        </div>
        </div>
      </div>
      
    </div>
    <Drawer title="Menu Bar" placement="right" onClose={onClose} open={open} width={"250px"}>
        {/* <ul className='mobile_menu'>
          {menu.map((e, i) => {
            return (
              <li key={i}>
                <a href={e.link} onClick={onClose}>{e.name}</a>
              </li>
            )
          })}
        </ul> */}
        <Menu
      style={{ width: '100%' }}
      mode="inline"
      items={menu}
    />
      </Drawer>
    </HeaderNewSection>
  )
}

export default Header;

const HeaderNewSection = styled.section`


  position: sticky;
  top:0;
  left: 0;
width: 100%;
display: inline-block;
/* position: relative; */
padding: 10px 0;
background: #fff;
z-index: 111;
box-shadow: 0 0 15px rgb(0 0 0 / 12%);

.header_align {
  width: 100%;
  display: inline-block;
  position: relative;
}
a {
  text-decoration: none !important;
  color: inherit;
}
.web_menu {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  min-height: 100px;
}
.web_menu ul {
  display: flex;
  align-items: center;
  justify-content: space-between;
  list-style: none;
  width: 100%;
  gap: 20px;
}
.logo {
  position: absolute;
  top:50%;
  left: 44%;
  transform: translate(-50%,-50%);
}
.web_menu ul li:nth-child(4) {
  padding: 0 100px 0 0;
}
.web_menu ul li:nth-child(1) { 
  margin:  0 -28px 0 0;
}
.web_menu ul li:nth-child(5) {
  padding: 0 0 0 80px;
}
.web_menu ul li {
  font-size: 16px;
  font-family: 'Helvetica';
  font-weight: 600;
  text-transform: uppercase;
  padding: 0;
}

.mobile_menu {
  display: none;
}
.web_menu ul {
  border-bottom: 0;
}
.web_menu ul::before {
  content: inherit;
}
.ant-menu-light.ant-menu-horizontal >.ant-menu-item::after, .ant-menu-light>.ant-menu.ant-menu-horizontal >.ant-menu-item::after, .ant-menu-light.ant-menu-horizontal >.ant-menu-submenu::after, .ant-menu-light>.ant-menu.ant-menu-horizontal >.ant-menu-submenu::after {
  border-bottom: 0;
}

@media screen and (max-width: 1200px) {
  .web_menu {
    display: none;
  }
  .header_align {
    padding: 0px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .logo {
    position: relative;
    left: 0;
    top:0;
    transform: inherit;
  }
  .mobile_menu {
    display: block;
    cursor: pointer;
  }
  .logo img {
    height: 50px;
  }

  


}











`;